import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { ArquivoFiltrosCriteria, ArquivoLogFiltrosCriteria } from "@workflow/types";

import { arquivoAuditoriaService } from "@/services/api/ArquivoAuditoriaService";

const MINUTE = 1000 * 60;
const LIST_STALE = 30 * 1000;
const FILTROS_STALE = 30 * MINUTE;

/**
 * Query keys da auditoria de arquivos. `list`/`logsList` são as keys base
 * invalidadas quando a grid precisa se refazer.
 */
export const arquivosAdminKeys = {
  list: ["arquivos-admin-listagem"] as const,
  filtros: ["arquivos-admin-filtros"] as const,
  logsList: ["arquivos-admin-logs-listagem"] as const,
  logsFiltros: ["arquivos-admin-logs-filtros"] as const,
};

export const arquivosAdminQueries = {
  list: (criteria: ArquivoFiltrosCriteria) =>
    queryOptions({
      queryKey: [...arquivosAdminKeys.list, criteria],
      queryFn: () => arquivoAuditoriaService.listArquivosPaginado(criteria),
      placeholderData: keepPreviousData,
      staleTime: LIST_STALE,
    }),

  filtros: () =>
    queryOptions({
      queryKey: arquivosAdminKeys.filtros,
      queryFn: () => arquivoAuditoriaService.getArquivoFiltros(),
      staleTime: FILTROS_STALE,
    }),

  logsList: (criteria: ArquivoLogFiltrosCriteria) =>
    queryOptions({
      queryKey: [...arquivosAdminKeys.logsList, criteria],
      queryFn: () => arquivoAuditoriaService.listLogsPaginado(criteria),
      placeholderData: keepPreviousData,
      staleTime: LIST_STALE,
    }),

  logsFiltros: () =>
    queryOptions({
      queryKey: arquivosAdminKeys.logsFiltros,
      queryFn: () => arquivoAuditoriaService.getLogFiltros(),
      staleTime: FILTROS_STALE,
    }),
};
